import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, BookOpen, ArrowRight } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { formatPrice } from "../mock/mock";
import { listFormations, mediaUrl } from "../lib/api";

export default function Formations() {
  const [FORMATIONS, setFormations] = useState([]);
  useReveal([FORMATIONS]);
  useEffect(() => {
    listFormations().then(setFormations).catch(() => setFormations([]));
  }, []);
  return (
    <div>
      <section className="relative pt-40 pb-20 bg-[#0b1f33] overflow-hidden">
        <div className="absolute inset-0 opacity-20 bg-cover bg-center" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1762968269894-1d7e1ce8894e)" }} />
        <div className="relative max-w-6xl mx-auto px-6 text-center">
          <p className="text-[#2f74c9] tracking-[0.3em] text-xs uppercase mb-4">Formations</p>
          <h1 className="font-serif-display text-4xl md:text-6xl text-white">Apprenez à investir</h1>
          <p className="text-white/70 mt-5 max-w-2xl mx-auto">
            Des formations conçues pour maîtriser l'investissement immobilier au Mexique, du financement à la fiscalité.
          </p>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
          {FORMATIONS.map((f, i) => (
            <div
              key={f.id}
              className={`reveal reveal-delay-${i % 3} group bg-white rounded-lg overflow-hidden border border-slate-100 shadow-sm hover:shadow-xl transition-shadow flex flex-col`}
            >
              <div className="relative h-52 overflow-hidden">
                <img src={mediaUrl(f.image)} alt={f.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <span className="absolute top-4 left-4 bg-white/90 text-[#0b1f33] text-xs font-600 px-3 py-1 rounded-full">
                  {f.level}
                </span>
                <span className="absolute top-4 right-4 bg-[#2f74c9] text-white text-xs font-700 px-3 py-1 rounded-full">
                  {f.format}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-serif-display text-2xl text-[#0b1f33] leading-tight">{f.title}</h3>
                <p className="text-slate-500 text-sm mt-3 leading-relaxed flex-1">{f.description}</p>
                <div className="flex items-center gap-4 text-xs text-slate-500 mt-5">
                  <span className="flex items-center gap-1.5"><Clock size={14} className="text-[#2f74c9]" /> {f.duration}</span>
                  <span className="flex items-center gap-1.5"><BookOpen size={14} className="text-[#2f74c9]" /> {f.lessons} leçons</span>
                </div>
                <div className="flex items-center justify-between mt-6 pt-5 border-t border-slate-100">
                  <span className="font-serif-display text-2xl text-[#0b1f33]">{formatPrice(f.price)}</span>
                  {f.cta_link ? (
                    <a href={f.cta_link} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 text-sm font-600 text-[#1156a7] hover:gap-2.5 transition-all">
                      {f.cta_label || "S'inscrire"} <ArrowRight size={16} />
                    </a>
                  ) : (
                    <Link to="/contact" className="flex items-center gap-1.5 text-sm font-600 text-[#1156a7] hover:gap-2.5 transition-all">
                      {f.cta_label || "S'inscrire"} <ArrowRight size={16} />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
